import React from "react";
import "./Categories.css";

function Categories({ categories, selected, onSelect }) {
  return (
    <nav className="categories">
      {categories.map(cat => (
        <button
          key={cat.id}
          className={selected === cat.id ? "active" : ""}
          onClick={() => onSelect(cat.id)}
        >
          <img src={cat.icon} alt={cat.name} className="category-icon" />
          <span>{cat.name}</span>
        </button>
      ))}
    </nav>
  );
}

export default Categories;